import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { isPinAuthGatePending } from '../../../util/pinBrowserFlags'
import { isAuthenticated } from '../../../util/authentication'
import { isAutoLoginEnabled } from '../../../util/backendProvider'
import { redirectToAutoLogin } from '../../../util/authProvider'
import ROUTES from '../../../assets/routes'

const AuthCheckerRoute = ({ children }: any) => {
    const authenticated = isAuthenticated()
    const autoLogin = isAutoLoginEnabled()
    const pinGatePending = isPinAuthGatePending()
    const [oauthRedirectFailed, setOauthRedirectFailed] = useState(false)

    useEffect(() => {
        if (pinGatePending || authenticated || !autoLogin) return
        redirectToAutoLogin().catch(() => {
            setOauthRedirectFailed(true)
        })
    }, [authenticated, autoLogin, pinGatePending])

    if (pinGatePending) {
        return children
    }

    if (!authenticated && autoLogin && !oauthRedirectFailed) {
        return null
    }

    if (authenticated) {
        const prevUrl = window.sessionStorage.getItem('prevUrl')
        if (prevUrl) {
            return <Navigate to={prevUrl} replace />
        }
        return <Navigate to={ROUTES.base} replace />
    }
    return children
}

export default AuthCheckerRoute
